document.addEventListener("DOMContentLoaded", function () {
  if (window.innerWidth > 767) { 
    // Function to handle smooth scrolling
    function smoothScroll(target) {
      const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = targetPosition - 200;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }

    // Event delegation for dynamically added links
    document.body.addEventListener("click", function (e) {
      if (
        e.target.classList.contains("list-menu__item") ||
        e.target.classList.contains("header__menu-item")
      ) {
        //e.preventDefault();

        document.querySelector(".section-header").classList.remove('menu-open');

        // Get the href attribute value without the '#' symbol
        var hrefValue = e.target.getAttribute("href").substring(1);

        // Check if the current page is the home page
        if (window.location.pathname === '/') {
          // Scroll to the section directly if on the home page
        const target = document.querySelector(`[data-section-id="${hrefValue}"]`);
          if (target) {
            smoothScroll(target);
          }
        } else {
          // Store the section ID in sessionStorage
          sessionStorage.setItem('scrollToSection', hrefValue);

          // Redirect to the home page
          window.location.href = '/';
        }
      }
    });

    // On the home page, check for stored section ID and scroll
    if (window.location.pathname === '/') {
      const sectionId = sessionStorage.getItem('scrollToSection');
      if (sectionId) {
        // Use the section ID to find the target element
        const target = document.querySelector(`[data-section-id="${sectionId}"]`);
        if (target) {
          smoothScroll(target);
        }
        // Remove the item from sessionStorage to avoid unwanted scrolling on future visits
        sessionStorage.removeItem('scrollToSection');
      }
    }
  }
  });